import { EmployeeDTO } from '@Models/model.types';
import { AvatarById } from '@tlx/astro-shared';
import { Label } from '@tlx/atlas';
import { employeeDetailsLink, employeeSalaryLink, proxyUserLink } from '@Util/links';
import { useIntl } from 'react-intl';

export function DisplayEmployee({ item, currentTab }: { item: EmployeeDTO; currentTab: string }) {
    const intl = useIntl();
    let employeeRedirectLink: string;
    if (item.isProxy) {
        employeeRedirectLink = proxyUserLink();
    } else if (currentTab === 'salary') {
        employeeRedirectLink = employeeSalaryLink(item.id);
    } else {
        employeeRedirectLink = employeeDetailsLink(item.id);
    }
    return (
        <div className="atl-flex atl-gap-8 atl-items-center">
            <AvatarById imageId={item.pictureId} name={item.displayName} />
            <Label className={'atl-truncate '} title={item.displayName}>
                <a href={employeeRedirectLink} className="tsk-text-underline">
                    {item.displayName}
                </a>
                {item.hasResigned && ` (${intl.formatMessage({ id: 'text_resigned' })})`}
            </Label>
        </div>
    );
}
